export const translations = {
  en: {
    translation: {
      appName: "FINsathi IT Portal",
      login: "Login",
      username: "Username",
      password: "Password",
      logout: "Logout",
      dashboard: "Dashboard",
      clientDatabase: "Client Database",
      downloads: "Downloads",
      userManagement: "User Management",
      settings: "Settings",
      ahmedabad: "Ahmedabad",
      palanpur: "Palanpur",
      addClient: "Add Client",
      uploadCSV: "Upload CSV",
      search: "Search",
      clientCode: "Client Code",
      pan: "PAN",
      name: "Name",
      dob: "Date of Birth",
      mobile: "Mobile",
      email: "Email",
      office: "Office",
      status: "Status",
      active: "Active",
      inactive: "Inactive",
      actions: "Actions",
      edit: "Edit",
      deactivate: "Deactivate",
      save: "Save",
      cancel: "Cancel",
      totalClients: "Total Clients",
      ahmedabadClients: "Ahmedabad Clients",
      palanpurClients: "Palanpur Clients",
      selectAll: "Select All",
      startDownload: "Start Download",
      financialYear: "Financial Year",
      documentTypes: "Document Types",
      aisPdf: "AIS PDF",
      tisPdf: "TIS PDF",
      form26AsPdf: "26AS PDF",
      form26AsText: "26AS Text",
      captchaRequired: "CAPTCHA Required",
      enterCaptcha: "Enter CAPTCHA",
      submit: "Submit",
      skipClient: "Skip This Client",
      downloadProgress: "Download Progress",
      processingClient: "Processing Client",
      loggingIn: "Logging in...",
      downloadComplete: "Download Complete!",
      failedClients: "Failed Clients",
      downloadZip: "Download ZIP",
      uploadCsvQuick: "Quick CSV Upload (without adding to database)",
      downloadTemplate: "Download Template",
      createUser: "Create User",
      officeAccess: "Office Access",
      both: "Both Offices",
      changePassword: "Change Password",
      currentPassword: "Current Password",
      newPassword: "New Password",
      language: "Language",
      english: "English",
      gujarati: "ગુજરાતી",
      welcomeBack: "Welcome back",
      automationRunning: "Automation is running in the background. Please wait and enter CAPTCHA when prompted.",
      selected: "selected",
      clients: "clients",
      files: "files",
    }
  },
  gu: {
    translation: {
      appName: "FINsathi IT પોર્ટલ",
      login: "લૉગિન",
      username: "વપરાશકર્તા નામ",
      password: "પાસવર્ડ",
      logout: "લૉગ આઉટ",
      dashboard: "ડેશબોર્ડ",
      clientDatabase: "ક્લાઈન્ટ ડેટાબેઝ",
      downloads: "ડાઉનલોડ",
      userManagement: "વપરાશકર્તા વ્યવસ્થાપન",
      settings: "સેટિંગ્સ",
      ahmedabad: "અમદાવાદ",
      palanpur: "પાલનપુર",
      addClient: "ક્લાઈન્ટ ઉમેરો",
      uploadCSV: "CSV અપલોડ",
      search: "શોધ",
      clientCode: "ક્લાઈન્ટ કોડ",
      pan: "PAN",
      name: "નામ",
      dob: "જન્મ તારીખ",
      mobile: "મોબાઈલ",
      email: "ઈમેઈલ",
      office: "ઑફિસ",
      status: "સ્થિતિ",
      active: "સક્રિય",
      inactive: "નિષ્ક્રિય",
      actions: "ક્રિયાઓ",
      edit: "સંપાદિત",
      deactivate: "નિષ્ક્રિય",
      save: "સાચવો",
      cancel: "રદ કરો",
      totalClients: "કુલ ક્લાઈન્ટ",
      ahmedabadClients: "અમદાવાદ ક્લાઈન્ટ",
      palanpurClients: "પાલનપુર ક્લાઈન્ટ",
      selectAll: "બધા પસંદ કરો",
      startDownload: "ડાઉનલોડ શરૂ કરો",
      financialYear: "નાણાકીય વર્ષ",
      documentTypes: "દસ્તાવેજ પ્રકાર",
      aisPdf: "AIS PDF",
      tisPdf: "TIS PDF",
      form26AsPdf: "26AS PDF",
      form26AsText: "26AS ટેક્સ્ટ",
      captchaRequired: "CAPTCHA જરૂરી",
      enterCaptcha: "CAPTCHA દાખલ કરો",
      submit: "સબમિટ",
      skipClient: "આ ક્લાઈન્ટ છોડો",
      downloadProgress: "ડાઉનલોડ પ્રગતિ",
      processingClient: "ક્લાઈન્ટ પ્રોસેસ",
      loggingIn: "લૉગ ઇન...",
      downloadComplete: "ડાઉનલોડ પૂર્ણ!",
      failedClients: "નિષ્ફળ ક્લાઈન્ટ",
      downloadZip: "ZIP ડાઉનલોડ",
      uploadCsvQuick: "ઝડપી CSV અપલોડ (ડેટાબેઝ વિના)",
      downloadTemplate: "ટેમ્પ્લેટ ડાઉનલોડ",
      createUser: "વપરાશકર્તા બનાવો",
      officeAccess: "ઑફિસ ઍક્સેસ",
      both: "બંને ઑફિસ",
      changePassword: "પાસવર્ડ બદલો",
      currentPassword: "વર્તમાન પાસવર્ડ",
      newPassword: "નવો પાસવર્ડ",
      language: "ભાષા",
      english: "English",
      gujarati: "ગુજરાતી",
      welcomeBack: "પાછા સ્વાગત",
      automationRunning: "ઓટોમેશન બેકગ્રાઉન્ડમાં ચાલી રહ્યું છે. કૃપા કરીને રાહ જુઓ અને CAPTCHA આવે ત્યારે દાખલ કરો.",
      selected: "પસંદ",
      clients: "ક્લાઈન્ટ",
      files: "ફાઈલ",
    }
  }
};
